import { render, staticRenderFns } from "./configExport.vue?vue&type=template&id=ed9c223e&scoped=true"
import script from "./configExport.vue?vue&type=script&lang=js"
export * from "./configExport.vue?vue&type=script&lang=js"
import style0 from "./configExport.vue?vue&type=style&index=0&id=ed9c223e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9c223e",
  null
  
)

export default component.exports